<script>
const axios = require("axios");

export default {
	mixins: [require("@/mixins/cookie-mixin").default],
	data() {
		return {
			// BACKEND_URL: "http://127.0.0.1:8000"
			// BACKEND_URL: "http://localhost/tele-retina/public"
			// BACKEND_URL: "http://134.209.93.150:1013"
			BACKEND_URL: "https://teleretina.tk"
		};
	},
	methods: {
		getBackendToken() {
			return this.getCookie("token");
		},
		setBackendToken(token) {
			this.setCookie("token", token, 1);
		},
		clearBackendToken() {
			this.setCookie("token", null, 0);
		},
		async getUser() {
			var token = this.getBackendToken();

			if (token == null || token == "") {
				return;
			}

			const url = this.BACKEND_URL + "/api/auth/me";

			var data = {
				token: token
			};

			// let thisVue = this;

			let config = {};

			var userInfo = null;

			await axios
				.post(url, data, config)
				.then(response => {
					userInfo = response.data;
				})
				.catch(error => {
					console.error(error);
				});

			return userInfo;
		}
	}
};
</script>